import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableStyle } from '../../../models/enums/tableStyle';
import { Sort } from '@angular/material/sort';
import { animate, transition, trigger, state, style } from '@angular/animations';
import { TopFlopService } from '../../../core/services/tables/top-flop.service';
import { TopFlopStore } from '../../../core/services/tables/top-flop.store';
import { InfoService } from '../../../core/services/tables-info/info.service';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-top-flop-table',
  templateUrl: './top-flop-table.component.html',
  styleUrls: ['./top-flop-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: 0, padding: 0 })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class TopFlopTableComponent implements OnInit {

  @Output() getData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updatePageSize: EventEmitter<any> = new EventEmitter<any>();

  @Input() style: TableStyle;
  @Input() totalPages;
  @Input() pageNumber;
  @Input() pageSize;
  @Input() state;
  @Input() showLoader;
  
  tableStyle = TableStyle;
  isAlreadyFetched: boolean;
  tableInfoExists: boolean;
  filter: string;
  ascending: boolean;


  constructor(
    private service: TopFlopService,
    public store: TopFlopStore,
    private infoService: InfoService,
    public dialogService: DialogService) {

  }

  ngOnInit(): void {
    if (this.state === 'expanded') {
      this.getRecords(this.pageNumber);
    }

    this.tableInfoExists = this.infoService.isThereInfo(this.store.title);
    this.isAlreadyFetched = this.state === 'expanded' ? true : false;
  }

  getRecords(pageNumber: number) {
    this.getData.emit({ pageNumber, filter: this.filter, ascending: this.ascending });
    this.isAlreadyFetched = true;
  }

  deepSortRecords({ active, direction }) {
    this.filter = active;
    this.ascending = direction === 'asc' ? true : direction === 'desc' ? false : null;
    this.getData.emit({ pageNumber: this.pageNumber, filter: this.filter, ascending: this.ascending });
  }

  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (!this.isAlreadyFetched) {
      this.getRecords(this.pageNumber);
    }
  }

  nextPage() {
    ++this.pageNumber;
    this.getRecords(this.pageNumber);
  }

  previousPage() {
    --this.pageNumber;
    this.getRecords(this.pageNumber);
  }

  firstPage() {
    this.pageNumber = 1;
    this.getRecords(this.pageNumber);
  }

  lastPage() {
    this.pageNumber = this.totalPages;
    this.getRecords(this.pageNumber);
  }

  updateSize(event: any) {
    this.updatePageSize.emit({ event, filter: this.filter, ascending: this.ascending });
  }

  sendSortingParam(sort: Sort) {
    this.service.sorting(sort);
  }

  openDialog() {
    const tableInfo = this.infoService.getTableInfo(this.store.title);
    this.dialogService.openTableInfoDialog(tableInfo);
  }
}
